import type { Component } from 'vue'
import {
  ClipboardList,
  Compass,
  FileText,
  FolderOpen,
  Image,
  Layers,
  Sparkles,
  Table,
  Zap,
} from 'lucide-vue-next'
import { ElementalTypeEnum } from '~~/src/types/elemental'

export interface NavigationItem {
  title: string
  icon: Component
  href: string
}

export interface CreateItem {
  title: string
  icon: Component
  colorClasses: string
  elementalType: ElementalTypeEnum | 'form'
}

export function useNavigationData() {
  const getNavigationItems = (): NavigationItem[] => [
    {
      title: 'Discover',
      icon: Compass,
      href: '/',
    },
    {
      title: 'Prompts',
      icon: Sparkles,
      href: '/prompts',
    },
    {
      title: 'AI Images',
      icon: Image,
      href: '/images',
    },
    {
      title: 'Automations',
      icon: Zap,
      href: '/automations',
    },
  ]

  const getCreateItems = (): CreateItem[] => [
    {
      title: 'Prompt',
      icon: Sparkles,
      colorClasses:
        'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
      elementalType: ElementalTypeEnum.Prompt,
    },
    {
      title: 'AI Image',
      icon: Image,
      colorClasses:
        'bg-pink-100 text-pink-600 dark:bg-pink-900/30 dark:text-pink-400',
      elementalType: ElementalTypeEnum.Image,
    },
    {
      title: 'Automation',
      icon: Zap,
      colorClasses:
        'bg-yellow-100 text-yellow-600 dark:bg-yellow-900/30 dark:text-yellow-400',
      elementalType: ElementalTypeEnum.Automation,
    },
    {
      title: 'Snippet',
      icon: Layers,
      colorClasses:
        'bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400',
      elementalType: ElementalTypeEnum.Snippet,
    },
    {
      title: 'Document',
      icon: FileText,
      colorClasses:
        'bg-cyan-100 text-cyan-600 dark:bg-cyan-900/30 dark:text-cyan-400',
      elementalType: ElementalTypeEnum.Document,
    },
    {
      title: 'Table',
      icon: Table,
      colorClasses:
        'bg-green-100 text-green-600 dark:bg-green-900/30 dark:text-green-400',
      elementalType: ElementalTypeEnum.Table,
    },
    {
      title: 'List',
      icon: FolderOpen,
      colorClasses:
        'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400',
      elementalType: ElementalTypeEnum.List,
    },
    {
      title: 'Form',
      icon: ClipboardList,
      colorClasses:
        'bg-purple-100 text-purple-600 dark:bg-purple-900/30 dark:text-purple-400',
      elementalType: 'form' as const,
    },
  ]

  return {
    getNavigationItems,
    getCreateItems,
  }
}
